export default __webpack_public_path__ + "static/me-lg-835fc5d8aa3fab95d3f547741de91791.png";